/*
 * NicheCanvas — Drawer "min-max" tweaks for the UpCart drawer.
 * Live on main since c88781b (T5 winner), loaded on every page via snippets/nc-frame-upsell.liquid.
 * Required while UpCart's discount-code field (discountCodeModule) is switched on: any theme that
 * serves traffic must load this file, or the field shows during automatic sales.
 * Slim header ("Your Cart (N)"), "<Discount Name> Applied · You saved $X" announcement
 * (dynamic — reads the live cart's real discount title from cart.js, falls back to
 * "SALE"; recomputes with the frame upsell), sticky footer, and collapses the
 * free-shipping progress bar once unlocked (keeps UpCart's "Free Shipping Unlocked!" text).
 * Hides UpCart's discount-code field while an automatic sale applies to the cart, so the
 * field can stay switched on in UpCart all year (no manual toggling per sale).
 * Idempotent + re-applied on every drawer render via MutationObserver + UpCart events.
 */
(function () {
  'use strict';

  function root() { return window.upcartDocumentOrShadowRoot || null; }
  function money(c) { c = (+c || 0) / 100; return '$' + c.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function discountTitle(c) {
    var apps = c && c.cart_level_discount_applications;
    if (apps && apps.length) { for (var i = 0; i < apps.length; i++) { if (apps[i] && apps[i].title) return String(apps[i].title); } }
    var items = (c && c.items) || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var da = allocs[k] && allocs[k].discount_application;
        if (da && da.title) return String(da.title);
      }
    }
    return 'SALE';
  }
  var lastSaved = -1;
  var lastTitle = '';

  function ensureStyle() {
    var r = root(); if (!r || r.querySelector('#nc-mm-style')) return;
    var st = document.createElement('style');
    st.id = 'nc-mm-style';
    st.textContent = '.upcart-footer{position:sticky;bottom:0;z-index:4;}'
      + '.nc-mm-shipdone [class*="progressBar"]{display:none!important;}';
    r.appendChild(st);
  }

  // Our own DOM writes must not count as a new drawer render (each render reads cart.js).
  // Nodes we wrote are remembered here and their mutation records dropped in settle().
  var observer = null;
  var written = [];

  function applyHeader() {
    var r = root(); var hdr = r && r.querySelector('.upcart-header-text');
    if (!hdr) return;
    if (/your cart/i.test(hdr.textContent || '')) return;
    var m = (hdr.textContent || '').match(/(\d+)/);
    hdr.textContent = 'Your Cart' + (m ? ' (' + m[1] + ')' : '');
    written.push(hdr);
  }

  function applyAnnouncement(saved, title) {
    var r = root(); var anc = r && r.querySelector('.upcart-announcement');
    if (!anc) return;
    written.push(anc);
    var ours = anc.getAttribute('data-nc-anc');
    if (!(saved > 0)) {
      // No discount in the cart.
      if (!ours) {
        // UpCart's own announcement (e.g. the "Buy 2 Get 1 Free" teaser the merchant
        // typed in the UpCart app). Remember it as the fallback and leave it visible.
        anc.__ncOrig = anc.innerHTML;
        return;
      }
      // The bar was OURS from a prior qualifying state and the discount just dropped:
      // hand control back to UpCart's native teaser instead of leaving an empty bar.
      // (Fall back to hiding only if we never captured a native teaser to restore.)
      if (anc.__ncOrig != null) { anc.innerHTML = anc.__ncOrig; anc.style.removeProperty('display'); }
      else { anc.style.setProperty('display', 'none', 'important'); }
      anc.style.removeProperty('background-color');
      anc.style.removeProperty('border-top');
      anc.style.removeProperty('border-bottom');
      anc.removeAttribute('data-nc-anc');
      lastSaved = -1;
      lastTitle = '';
      return;
    }
    var label = (title || 'SALE').toUpperCase();
    anc.setAttribute('data-nc-anc', '1');
    anc.style.removeProperty('display');
    anc.style.setProperty('background-color', '#E8F5E9', 'important');
    anc.style.setProperty('border-top', '1px solid #C8E6C9', 'important');
    anc.style.setProperty('border-bottom', '1px solid #C8E6C9', 'important');
    if (saved === lastSaved && label === lastTitle && /applied/i.test(anc.textContent || '')) return;
    anc.innerHTML = '<p style="margin:0;line-height:1.3;"><span style="color:#2E7D32;"><strong>' + esc(label) + ' APPLIED</strong></span> <span style="color:#1B5E20;"><strong>· You saved ' + money(saved) + '</strong></span></p>';
    lastSaved = saved;
    lastTitle = label;
  }

  // A code cannot combine with an automatic sale, so the code field is hidden while one applies to
  // the cart and shown again as soon as none does. Read from cart.js, nothing is hardcoded.
  // BUY 2 GET 1 FREE (a 100% free item) is not a sale. Until the first cart read the field stays
  // hidden, so it never flashes during a sale; if cart.js fails it falls back to UpCart's default.
  function hasAutomaticSale(c) {
    function isSale(da, amount) {
      if (!da || da.type === 'discount_code' || !(amount > 0)) return false;
      return !(da.value_type === 'percentage' && parseFloat(da.value) >= 100);
    }
    var items = (c && c.items) || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        if (allocs[k] && isSale(allocs[k].discount_application, allocs[k].amount)) return true;
      }
    }
    var apps = (c && c.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      if (apps[i] && isSale(apps[i], apps[i].total_allocated_amount)) return true;
    }
    return false;
  }
  var codeFieldHidden = null; // null: unknown or empty cart (kept hidden; an empty cart has no field)
  function codeFieldState(c) { return c.items.length ? hasAutomaticSale(c) : null; }
  function applyCodeField(hide) {
    var r = root(); if (!r) return;
    var st = r.querySelector('#nc-mm-codefield');
    if (hide && !st) {
      st = document.createElement('style');
      st.id = 'nc-mm-codefield';
      st.textContent = '.upcart-discount-code-module{display:none!important;}';
      r.appendChild(st);
    } else if (!hide && st) {
      st.remove();
    }
  }

  function applyFreeShip() {
    var r = root(); var rew = r && r.querySelector('.upcart-rewards');
    if (!rew) return;
    var msg = (rew.textContent || '').toLowerCase();
    var unlocked = msg.indexOf('more') < 0 && msg.indexOf('add') < 0 && (msg.indexOf('unlock') >= 0 || msg.indexOf('free shipping') >= 0);
    if (unlocked) rew.classList.add('nc-mm-shipdone'); else rew.classList.remove('nc-mm-shipdone');
  }

  // A mutation is ours when it hits a node we just wrote or only adds/removes our nc-mm styles.
  function isOwnStyle(node) { return !!(node && node.id && /^nc-mm-/.test(node.id)); }
  function isOwnRecord(rec) {
    if (written.indexOf(rec.target) >= 0) return true;
    var nodes = Array.prototype.slice.call(rec.addedNodes || []).concat(Array.prototype.slice.call(rec.removedNodes || []));
    return nodes.length > 0 && nodes.every(isOwnStyle);
  }
  // Called right after our writes, in the same task: the pending records are ours unless shown otherwise.
  function settle() {
    var records = observer ? observer.takeRecords() : [];
    var foreign = records.some(function (rec) { return !isOwnRecord(rec); });
    written = [];
    if (foreign) schedule();
  }

  // The frame upsell (nc-frame-upsell.js) inserting its block or style is not a cart change,
  // nor is our code-field style toggled from upcartModifyCart below.
  function isThemeNode(node) {
    return !!(node && node.nodeType === 1
      && ((node.classList && node.classList.contains('nc-fu')) || node.id === 'nc-fu-style' || isOwnStyle(node)));
  }
  function onMutations(records) {
    var relevant = records.some(function (rec) {
      var nodes = Array.prototype.slice.call(rec.addedNodes || []).concat(Array.prototype.slice.call(rec.removedNodes || []));
      return !(nodes.length > 0 && nodes.every(isThemeNode));
    });
    if (relevant) schedule();
  }

  // One shared cart read with the other drawer scripts (assets/nc-drawer-cart.js), own fetch otherwise.
  function readCart() {
    if (window.NCDrawerCart && typeof window.NCDrawerCart.read === 'function') return window.NCDrawerCart.read();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function apply() {
    ensureStyle();
    applyHeader();
    applyFreeShip();
    applyCodeField(codeFieldHidden !== false);
    settle();
    readCart()
      .then(function (c) {
        if (!c || !Array.isArray(c.items)) throw new Error('bad cart');
        applyAnnouncement(c.total_discount, discountTitle(c));
        codeFieldHidden = codeFieldState(c);
        applyCodeField(codeFieldHidden !== false);
        settle();
      })
      // A failed read settles on UpCart's default (field shown) once, so no hide/show loop.
      .catch(function () { if (codeFieldHidden === null) { codeFieldHidden = false; applyCodeField(false); } settle(); });
  }

  // UpCart passes every new cart through window.upcartModifyCart (read from window at each call)
  // before rendering it: decide the field there too, so it is already hidden when the first sale
  // item renders. Chains to any existing hook and never changes the cart.
  var prevModifyCart = window.upcartModifyCart;
  window.upcartModifyCart = function (cart) {
    try {
      if (cart && Array.isArray(cart.items)) {
        codeFieldHidden = codeFieldState(cart);
        applyCodeField(codeFieldHidden !== false);
      }
    } catch (e) {}
    return typeof prevModifyCart === 'function' ? prevModifyCart.apply(this, arguments) : undefined;
  };

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 180); }

  function start() {
    var r = root(); if (!r) return false;
    // nc-drawer-tracking.js relies on these reads for the rush check while this script runs.
    if (window.NCDrawerCart) window.NCDrawerCart.minmaxActive = true;
    applyCodeField(codeFieldHidden !== false); // before the first cart read: no flash of the field
    try {
      observer = new MutationObserver(onMutations);
      observer.observe(r, { childList: true, subtree: true });
    } catch (e) { observer = null; }
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](schedule); } catch (e) {} }
    });
    schedule();
    return true;
  }

  var n = 0;
  var poll = setInterval(function () {
    if (window.upcartDocumentOrShadowRoot && start()) { clearInterval(poll); return; }
    if (++n > 100) clearInterval(poll);
  }, 300);
})();
